import { type ITemplateContext } from '../templating';

export interface IBaseTemplateContext extends ITemplateContext {
  nowDate: string;
  nowTime: string;
  nowYear: string;
  nextYear: string;
}
